import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { State } from '../../State';
import { GetTEGueltigkeitenRequest } from '../../State/actions/mdqx/te-gueltigkeit.actions';
import { getTEGueltigkeitenFetched } from '../../State/selectors/mdqx/selectors';
@Injectable({
    providedIn: 'root',
})

export class TEGueltigkeitResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getTEGueltigkeitenFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetTEGueltigkeitenRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
